module.exports = __webpack_public_path__ + "static/media/dummy_user2.8f5aec00.svg";